import { AnimatePresence, m } from 'framer-motion';
import { isEmpty } from 'lodash';
import { FC } from 'react';
import { productDetailPayloadToBaseCarData } from 'src/data/ProductApi/ProductDetailPayloadToBaseCarData';
import { ProductDetailsPayload } from 'src/types/ProductDetail.type';
import { SWRResponse } from 'swr';

import classNames from 'classnames';
import { LazyMotionWrapper } from 'src/general/components/LazyMotionWrapper/LazyMotionWrapper';
import { Image } from '../../../general/components/Image/Image';
import styles from './CarComparisonBannerThumbnails.module.scss';

type Props = {
  vehicle1?: SWRResponse<ProductDetailsPayload>;
  vehicle2?: SWRResponse<ProductDetailsPayload>;
};

export const CarComparisonBannerThumbnails: FC<Props> = ({ vehicle1, vehicle2 }) => {
  const thumbnail1 = getCarThumbnailUrl(vehicle1);
  const thumbnail2 = getCarThumbnailUrl(vehicle2);
  const hasThumbnail = !!thumbnail1 || !!thumbnail2;

  return (
    <LazyMotionWrapper>
      <AnimatePresence initial={false}>
        {hasThumbnail && (
          <m.div
            className={classNames(styles.root, {
              [styles.rootThumbnails2]: thumbnail1 && thumbnail2,
            })}
            animate={{ opacity: 1 }}
            transition={{ ease: 'easeInOut', duration: 0.2 }}
          >
            <Thumbnail url={thumbnail1 ?? ''} />
            <Thumbnail url={thumbnail2 ?? ''} />
          </m.div>
        )}
      </AnimatePresence>
    </LazyMotionWrapper>
  );
};

const Thumbnail: FC<{ url: string }> = ({ url }) => (
  <div className={styles.thumbnail}>
    {!isEmpty(url) && <Image src={url} className={styles.thumbnailImage} width={68} height={36} alt="" />}
  </div>
);

const getCarThumbnailUrl = (vehicle?: SWRResponse<ProductDetailsPayload>): string | null => {
  if (vehicle?.error || vehicle?.isLoading) {
    return '';
  }
  if (vehicle?.data) {
    const carData = productDetailPayloadToBaseCarData(vehicle.data);
    return carData.imageUrl;
  }

  return null;
};
